<template>
  <div class="mail_image" v-if="image != null">
    <section class="no_padding">
      <h2>{{ title }}</h2>

      <div v-if="image != null" class="mail_image_box text_center">
        <img :src="imageURL" />
      </div>
    </section>
    <section class="mail_image_link text_center">
      <p>
        <a href="#" class="arrow link_main--text" @click.prevent="$router.go(-1)">{{ linkWord }}に戻る</a>
      </p>
    </section>
  </div>
  <div v-else-if="isNotFound">
    <NotFound />
  </div>
</template>

<script>
import { IMAGE_URL } from '@/common/config'
import { GET_MESSAGE_IMAGE } from '@/store/message/actions'
import NotFound from '@/components/404.vue'

export default {
  name: 'MailImage',
  components: {
    NotFound
  },
  data () {
    return {
      type: this.$route.params.type,
      id: this.$route.params.id,
      image: null,
      isNotFound: false
    }
  },
  computed: {
    title () {
      let titleStr = '先生より受け取った画像'
      if (this.type === 'received') {
        titleStr = '先生に送信した画像'
      }
      return titleStr
    },
    linkWord () {
      let str = '鑑定結果詳細'
      if (this.type === 'received') {
        str = '鑑定依頼詳細'
      }
      return str
    },
    imageURL () {
      return (this.image.token != null && this.image.token.length > 0) ? IMAGE_URL + this.image.token : ''
    }
  },
  methods: {
    getImage () {
      this.$store.dispatch(GET_MESSAGE_IMAGE, {
        id: this.id,
        params: {
          params: {
            type: this.type
          }
        }
      })
        .then((data) => {
          this.image = data
        })
        .catch((error) => {
          if (error.errorStatus === 402) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else if (error.errorStatus === 404) {
            this.isNotFound = true
          } else {
            this.$router.pushIsses({ name: 'MailList' })
          }
        })
    }
  },
  created () {
    this.getImage()
  }
}
</script>
